import { createSignal } from 'solid-js';

export type ToastKind = 'info' | 'error';
export type Toast = { id: number; kind: ToastKind; text: string };

export const [selectedId, setSelectedId] = createSignal<number | null>(null);
export type ActiveView = 'slots' | 'preview';
export const [activeView, setActiveView] = createSignal<ActiveView>('slots');
export const [pdfExporting, setPdfExporting] = createSignal(false);
export const [pngExporting, setPngExporting] = createSignal(false);
export const [toasts, setToasts] = createSignal<Toast[]>([]);

let nextToastId = 1;
const TOAST_TTL_MS = 5000;

export function pushToast(toast: Omit<Toast, 'id'>): void {
  const id = nextToastId++;
  setToasts(prev => [...prev, { id, ...toast }]);
  setTimeout(() => dismissToast(id), TOAST_TTL_MS);
}

export function dismissToast(id: number): void {
  setToasts(prev => prev.filter(t => t.id !== id));
}
